$.fn.rotator = function() {

	return this.each(function() {
		var $rotator = $(this);
		var $progressPointers, $images;
		var bannersLength, delay, delayedNextOn, cooldownTimer;
		var currentPosition = 0;
		var bannerChanging = false;

		function setPosition(position) {
			var nextBanner = (position > currentPosition);
			if (position < 0) {
				position = bannersLength - 1;
			}
			if (position > bannersLength - 1) {
				position = 0;
			}
			if (position != currentPosition) {

				if (nextBanner) {
					$rotator.addClass('next-banner');
				} else {
					$rotator.addClass('previous-banner');
				}
				$rotator.addClass('shift-' + position);
				$rotator.removeClass('shift-' + currentPosition);

				if(position == (bannersLength - 1)) {
					$rotator.addClass('shift-last');
				} else {
					$rotator.removeClass('shift-last');
				}

				bannerChanging = true;
				setTimeout(function() {
					$rotator.removeClass('next-banner previous-banner');
					bannerChanging = false;
				}, 600);

				currentPosition = position;
			}
		}
		function nextBanner() {
			setPosition(currentPosition + 1);
		}
		function previousBanner() {
			setPosition(currentPosition - 1);
		}
		function delayedNextBanner() {
			setInterval(function() {
				if (delayedNextOn) {
					nextBanner();
				}
			}, delay)
		}
		function cooldown(time) {
			delayedNextOn = false;
			if (cooldownTimer) {
				clearTimeout(cooldownTimer);
			}
			cooldownTimer = setTimeout(function() {
				delayedNextOn = true;
				cooldownTimer = false;
			}, time);
		}
		function cloneDoubleRotator(){
			$rotator.find('.js-banner-item').clone().appendTo($rotator.find('.banners'));
			$rotator.addClass('double-rotator');
			bannersLength = 4;
		}
		function setElements(){
			$progressPointers = $('.js-rotator-pointer', $rotator);
			$images = $('img.lazy', $rotator);
			bannersLength = $rotator.find('.js-banner-item').length;
			delay = $rotator.data('delay');
			delayedNextOn = bannersLength > 1;
			if (bannersLength === 2) {
				cloneDoubleRotator();
			}
		}
		function setEvents(){
			$progressPointers.on('click', function() {
				setPosition($(this).index());
				cooldown(3000);
			});
			$rotator.swipe({
				swipe: function(event, direction, distance, duration, fingerCount, fingerData) {
					if(!bannerChanging) {
						switch (direction) {
							case 'left':
								nextBanner();
								break;
							case 'right':
								previousBanner();
								break;
						}
					}
					cooldown(3000);
				},
				excludedElements: "button, input, select, textarea, .noSwipe",
				allowPageScroll: "vertical"
			});
			delayedNextBanner();
		}
		function init(){
			setElements();
			setEvents();
		}

		init();
	});
};
